import { useFetcher } from "@remix-run/react";
import type { CartFlatten, CheckoutCreateAction } from "~/types";
import { isBlackFridayPromoEnabled } from "~/utils/dates";
import loadersvg from "../../images/loader.svg";
import Alert from "../alert.component";
import { NeumButton } from "../neum.component";

export default function OrderSummary({ cart }: { cart: CartFlatten }) {
  // TODO: probably we don't need to use useFetcher here,a regular form will work because the redirect is in the /cart action
  const checkout = useFetcher<CheckoutCreateAction>();
  const CheckoutButton = ({ cart }: { cart: CartFlatten }) => {
    return (
      <checkout.Form className="space-y-6" action="/cart" method="post">
        <NeumButton rounded={true}>
          <input
            id="checkoutUrl"
            name="checkoutUrl"
            type="checkoutUrl"
            required
            defaultValue={cart.checkoutUrl as string}
            className="hidden"
          />
          <button
            type="submit"
            id="proceed-to-checkout"
            disabled={checkout.state === "submitting"}
            className="text-white-700 group-hover:text-white-800 block w-full border-transparent bg-transparent text-center text-sm font-bold focus:border-transparent focus:ring-0"
          >
            {checkout.state !== "idle" ? (
              <img className="mx-auto my-[-18px] h-14 w-14" src={loadersvg} alt="Loading" />
            ) : (
              "Proceed to checkout"
            )}
          </button>
        </NeumButton>
      </checkout.Form>
    );
  };

  const showDiscount = isBlackFridayPromoEnabled();

  return (
    <section
      aria-labelledby="summary-heading"
      className="mt-10 px-0 sm:p-6 md:mt-16 md:px-4 lg:col-span-4 lg:mt-0 lg:pr-0 lg:pt-1.5"
    >
      {checkout.state === "idle" && checkout.data && checkout.data.error ? (
        <Alert message={checkout.data.error} typeAlert="Error" />
      ) : null}

      <h2 id="summary-heading" className="text-xl font-extrabold dark:text-white">
        Order summary
      </h2>

      <dl className="mt-4 space-y-6">
        <div className="flex items-center justify-between">
          <dt className="text-base text-admirerBlack-700 dark:text-admirerBlack-100 md:text-lg">Subtotal</dt>
          <dd id="subtotal" className="text-base dark:text-white md:text-lg">
            <span id="value" className={showDiscount ? "text-red-600" : ""}>
              ${cart.cost.subtotalAmount.amount}
            </span>
            <span id="currency"> {cart.cost.subtotalAmount.currencyCode}</span>
          </dd>
        </div>
      </dl>

      <div className="mt-2 grid grid-cols-6 gap-4">
        <div className="col-span-4 col-end-6 mt-4 md:mt-12">
          <CheckoutButton cart={cart} />
        </div>
      </div>
    </section>
  );
}
